// Generated by scripts/update-seeq-icons.js from src/svg/seeq/import.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcImport = {
  prefix: 'fak',
  iconName: 'import' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f927',
    'M266.2 599l245.8 235.6 245.8-235.6c10.2-10.2 5.1-30.7-10.3-30.7h-168.9v-537.6c0-10.2-5.1-15.4-15.4-15.3h-102.4c-10.2 0-15.4 5.1-15.4 15.3v542.7h-168.9c-15.4 0-25.6 15.4-10.3 25.6zM906.2 373.8h-184.3c-10.2 0-15.4 5.1-15.3 15.3v51.2c0 10.2 5.1 15.4 15.3 15.4h184.3c20.5 0 35.8 15.4 35.9 35.8v394.3c0 20.5-15.4 35.8-35.9 35.8h-788.4c-20.5 0-35.8-15.4-35.9-35.8v-389.2c5.1-20.5 20.5-35.8 35.9-35.8h184.3c10.2 0 15.4-5.1 15.3-15.4v-51.2c0-10.2-5.1-15.4-15.3-15.3h-184.3c-66.6-5.1-117.8 51.2-117.8 117.7v394.3c0 66.6 51.2 117.8 117.8 117.7h783.3c66.6 0 117.8-51.2 117.8-117.7v-394.3c5.1-66.6-46.1-122.9-112.7-122.8z',
  ],
} satisfies IconDefinition;
